export default "__VITE_ASSET__y7MGViZa__"